import { OpenStreetMapProvider, GeoSearchControl } from 'leaflet-geosearch'
import { MapControl, withLeaflet } from 'react-leaflet';

class Search extends MapControl {

  createLeafletElement() {
    return GeoSearchControl({
      provider: new OpenStreetMapProvider(),
      style: 'bar',
      showMarker: true,
      showPopup: false,
      autoClose: true,
      retainZoomLevel: false,
      animateZoom: true,
      keepResult: false,
      searchLabel: 'search'
    });
  }
}

export default withLeaflet(Search);